import { IconType } from 'react-icons';
import { LuBookOpenText, LuGauge, LuLandmark, LuScrollText, LuWorkflow } from 'react-icons/lu';

import { ProjectKnowledgeType } from '../../entities/project-knowledge';

// Colors reuse the app's existing DaisyUI semantic tokens rather than inventing new hues —
// info/primary/ghost/success, same as everywhere else in the app.
export const TYPE_META: Record<
  ProjectKnowledgeType,
  { label: string; description: string; color: string; badgeClass: string; Icon: IconType }
> = {
  metric: {
    label: 'Metric',
    description: 'A KPI or number the AI should understand for this project',
    color: '#6f9bbf',
    badgeClass: 'badge-info',
    Icon: LuGauge,
  },
  workflow: {
    label: 'Workflow',
    description: 'How your team works — process, cadence, handoffs',
    color: '#ff8a3e',
    badgeClass: 'badge-primary',
    Icon: LuWorkflow,
  },
  convention: {
    label: 'Convention',
    description: 'A rule or standard your team follows',
    color: '#9ca3af',
    badgeClass: 'badge-ghost',
    Icon: LuScrollText,
  },
  guide: {
    label: 'Guide',
    description: 'Reference docs — indexed for AI semantic search',
    color: '#6fbf85',
    badgeClass: 'badge-success',
    Icon: LuBookOpenText,
  },
  adr: {
    label: 'ADR',
    description: 'An architecture decision — context, decision, consequences',
    color: '#c07ee0',
    badgeClass: 'badge-secondary',
    Icon: LuLandmark,
  },
};
